import styled from 'styled-components';
import { themeVar } from '@/styles/theme';
import { CloseInfoIcon } from '@/assets/icons/info-icons/closeInfo';
import { ErrorText } from '@/components/basicComponents/input';

export const ErrorStatus = () => {
  return (
    <>
      <IconWrapper>
        <ErrorIcon>
          <CloseInfoIcon width={50} height={50} fill={themeVar('context.light')} />
        </ErrorIcon>
      </IconWrapper>
      <ErrorText size="lg">The link you are trying to access does not exist.</ErrorText>
    </>
  );
};

const IconWrapper = styled.div`
  padding: 80px 0 40px 0;
  display: flex;
  justify-content: center;
`;

const ErrorIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 129px;
  height: 129px;
  border-radius: 50%;
  background-color: ${themeVar('context.error')};
`;
